// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"8":"12e78a2e9732f2bfe07a","79":"ead5bc4d2592df019ef8","442":"242df5cf04eee1be9a62","585":"6fccca4c630cbc5d8f4f","700":"31aa7e1eac08947f692e","938":"79b6483566ad3ebf938e","940":"2fbfa63a4bc100a00b1b"}[chunkId] + ".js";
};